
import CompoundListComponent from "../../../components/compounds/Index.vue";

export default {
  components: {
    CompoundListComponent
  }
}
